import 'core-js/stable'
import 'regenerator-runtime/runtime'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import { createStore } from './store'

import './styles/index.scss'

import App from './App'

const store = createStore()

const Main = () => {
  return (
    <StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>
  )
}

const rootEl = document.getElementById('__root')
const root = createRoot(rootEl)

root.render(<Main />)
